/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import Fieldset from 'components/Fieldset';
import Legend from 'components/Legend';
import Text from 'components/Text';
import LoadingIndicator from 'components/LoadingIndicator';
import RoleSelector from 'chat/components/RoleSelector';
import Button from 'components/Button';
import Link from 'components/Link';
import Glyph from 'components/Glyph';
import LinkConstants from 'constants/LinkConstants';

import ROLE_SECTION_QUERY from './queries/RoleSectionQuery.gql';

import type { RoleSectionQuery } from './queries/__generated__/RoleSectionQuery';

import './RoleSection.scss';

type Props = {
  data: ReactApolloData<RoleSectionQuery>,
};

function RoleSection(props: Props) {
  const { loading, me } = props.data;

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!me || !me.role) {
    return <Text>Failed to load user role.</Text>;
  }

  const { role } = me;

  if (!me) {
    return null;
  }

  return (
    <div className="UserProfileView-section RoleSection">
      <Fieldset>
        <Legend>Role</Legend>
        <RoleSelector value={role} disabled />
        <Button disabled>Save</Button>
        <div className="RoleSection-contact-support">
          <Glyph
            color="eclipse"
            name="explanation-circle"
            size="small"
            className="RoleSection-contact-support-icon"
          />
          <Text>
            If you need to change your role, please{' '}
            <Link href={LinkConstants.CONTACT_FORM}>contact support</Link>.
          </Text>
        </div>
      </Fieldset>
    </div>
  );
}

const withData = graphql(ROLE_SECTION_QUERY);

export { RoleSection };
export default withData(RoleSection);
